// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DynamicContent-Drawer .EditRatesForm .col-md-4,
.DynamicContent-Drawer .EditRatesForm .col-md-6 {
  width: 100%;
}

.EditRatesForm .add-rate-btn {
  background: none;
  color: var(--bs-green);
  border: 1px solid var(--bs-green);
}
.EditRatesForm .add-rate-btn i {
  border: 1px solid var(--bs-green);
  border-radius: 0.15rem;
  margin-right: 0.5rem;
}
.EditRatesForm .add-rate-btn:hover {
  transition: color 0.5s;
  background-color: var(--bs-green);
  color: #fff;
}
.EditRatesForm .add-rate-btn:hover i {
  transition: border 0.5s;
  border: 1px solid #fff;
  color: #fff;
}
.EditRatesForm .RateItem-Currency {
  display: flex;
}
.EditRatesForm .RateItem-Currency .Field {
  margin-top: 0.5rem;
  padding-bottom: 0;
}
.EditRatesForm .RateItem-Currency .Field:first-child {
  width: 75%;
}
.EditRatesForm .RateItem-Currency .Field:first-child input {
  border-radius: 0.25rem 0 0 0.25rem;
  border-color: var(--bs-secondary-subtle);
  border-right: none;
}
.EditRatesForm .RateItem-Currency .Field:first-child + .Field {
  width: 25%;
}
.EditRatesForm .RateItem-Currency .Field:first-child + .Field input {
  background-color: var(--bs-secondary-subtle);
  border-color: var(--bs-secondary-subtle);
  border-radius: 0 0.25rem 0.25rem 0;
}
.EditRatesForm .FormContainer-Control button {
  display: flex;
  align-items: center;
  height: 100%;
}
.EditRatesForm .FormContainer-Control:hover {
  transition: background-color 0.35s;
  background-color: var(--bs-danger) !important;
}
.EditRatesForm .FormContainer-Control:hover button i {
  transition: color 0.35s;
  color: #fff !important;
}
.EditRatesForm .input-group,
.EditRatesForm .Field {
  margin: 1.25rem 0 0 0;
}
.EditRatesForm .input-group > .Field,
.EditRatesForm .Field > .Field {
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/EditRatesForm/styles.scss"],"names":[],"mappings":"AAEI;;EAEE,WAAA;AADN;;AAOE;EACE,gBAAA;EACA,sBAAA;EACA,iCAAA;AAJJ;AAKI;EACE,iCAAA;EACA,sBAAA;EACA,oBAAA;AAHN;AAKI;EACE,sBAAA;EACA,iCAAA;EACA,WAAA;AAHN;AAIM;EACE,uBAAA;EACA,sBAAA;EACA,WAAA;AAFR;AAOE;EACE,aAAA;AALJ;AAOI;EACE,kBAAA;EACA,iBAAA;AALN;AAQI;EACE,UAAA;AANN;AAOM;EACE,kCAAA;EACA,wCAAA;EACA,kBAAA;AALR;AAQM;EACE,UAAA;AANR;AAOQ;EACE,4CAAA;EACA,wCAAA;EACA,kCAAA;AALV;AAYI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAVN;AAYI;EACE,kCAAA;EACA,6CAAA;AAVN;AAYM;EACE,uBAAA;EACA,sBAAA;AAVR;AAcE;;EAEE,qBAAA;AAZJ;AAaI;;EACE,SAAA;AAVN","sourcesContent":[".DynamicContent-Drawer {\n  .EditRatesForm {\n    .col-md-4,\n    .col-md-6 {\n      width: 100%;\n    }\n  }\n}\n\n.EditRatesForm {\n  .add-rate-btn {\n    background: none;\n    color: var(--bs-green);\n    border: 1px solid var(--bs-green);\n    i {\n      border: 1px solid var(--bs-green);\n      border-radius: 0.15rem;\n      margin-right: 0.5rem;\n    }\n    &:hover {\n      transition: color 0.5s;\n      background-color: var(--bs-green);\n      color: #fff;\n      i {\n        transition: border 0.5s;\n        border: 1px solid #fff;\n        color: #fff;\n      }\n    }\n  }\n\n  .RateItem-Currency {\n    display: flex;\n\n    .Field {\n      margin-top: 0.5rem;\n      padding-bottom: 0;\n    }\n\n    .Field:first-child {\n      width: 75%;\n      input {\n        border-radius: 0.25rem 0 0 0.25rem;\n        border-color: var(--bs-secondary-subtle);\n        border-right: none;\n      }\n\n      + .Field {\n        width: 25%;\n        input {\n          background-color: var(--bs-secondary-subtle);\n          border-color: var(--bs-secondary-subtle);\n          border-radius: 0 0.25rem 0.25rem 0;\n        }\n      }\n    }\n  }\n\n  .FormContainer-Control {\n    button {\n      display: flex;\n      align-items: center;\n      height: 100%;\n    }\n    &:hover {\n      transition: background-color 0.35s;\n      background-color: var(--bs-danger) !important;\n\n      button i {\n        transition: color 0.35s;\n        color: #fff !important;\n      }\n    }\n  }\n  .input-group,\n  .Field {\n    margin: 1.25rem 0 0 0;\n    > .Field {\n      margin: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
